import React, { useState } from "react"

import styled from "styled-components"
import Button from './common/Button'


const Container = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 100%;
    a {
        color: var(--cPrimaryLight);
        
        &:visited,
        &:active {
            color: var(--cPrimaryLight);
        }
        &:hover{
            color: var(--cThird);
        }
    }
`
const Share = () => { 
    const [show, setShow] = useState(false)
    const data = {
        url: encodeURIComponent('https://tagplus.com.br/'),
        text: 'Sistema de Gestão Comercial Online com NF-e - TagPlus NF-e',
        desc: 'Sistema Online de Gestão Comercial, com NF-e, NFS-e, Controle Financeiro, Acompanhamento de NF-e, Sistema emissão Nota Fiscal Eletrônica.'
    }
    const items = ( show ? 
        <Container>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${data.url}`} target="__blank"><i className="fab fa-facebook-f"/></a>
            <a href={`https://twitter.com/intent/tweet?text=${data.text}&url=${data.url}&via=TagPlusOficial ;)`} target="__blank"><i className="fab fa-twitter"/></a>
            <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${data.url}&title=${data.text}`} target="__blank"><i className="fab fa-linkedin-in"/></a>
            <a href={`https://wa.me/?text=${data.desc} em ${data.url}`} target="__blank"><i className="fab fa-whatsapp"/></a>
        </Container>  : 
         <Button flat primary handleClick={() => setShow(true)}>
         Compartilhar <i className='far fa-share-alt'></i>
     </Button>
        )
    return (
        items
)
}
export default Share
